import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth.service';

function buildRedirectToLogin(router: Router): UrlTree {
	return router.createUrlTree(['/auth/login']);
}

export const authGuard: CanActivateFn = () => {
	const auth = inject(AuthService);
	const router = inject(Router);

	const token = auth.getToken();

	if (!token) return buildRedirectToLogin(router);

	return true;
};

export const authChildGuard: CanActivateChildFn = () => {
	const auth = inject(AuthService);
	const router = inject(Router);

	const token = auth.getToken();

	if (!token) return buildRedirectToLogin(router);

	return true;
};
